module.exports = __webpack_public_path__ + "077973244b97b570696facdab2549d84.pdf";